import {environment} from '../../../../environments/environment';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {throwError} from 'rxjs';
import {CustomsValidators} from '../../validators/custom.validators';

@Injectable()
export class FormCheckPolicyService {
  urlPolicyFormPage: string;

  constructor(private http: HttpClient) {
    this.urlPolicyFormPage = `${environment.bffBaseUrl}/pages/policy-form`;
  }

  getCheckPolicy() {
    const urlBuilder = this.urlPolicyFormPage;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  postCheckPolicy(SiteId, type, commentary, file) {
    const formData: FormData = new FormData();
    formData.append('ExcelFile', file);
    formData.append('siteId', SiteId);
    formData.append('Types', JSON.stringify(type));
    formData.append('commentary', commentary);
    const urlBuilder = this.urlPolicyFormPage;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, formData) : throwError(CustomsValidators.msgNotValidUrl);
  }
}
